import styled from "styled-components";
import { Button } from "antd";

import colors from "constants/palette";

export default function Index(props) {
  return (
    <CustomButton size={props.size ? props.size : "large"} {...props}>
      {props.children}
    </CustomButton>
  );
}
const CustomButton = styled(Button)`
  background-color: ${({ color }) => (color ? color : colors.primary)};
  color: ${colors.white};
  fill: ${colors.white};
  border-radius: 8px;
  border-width: 2px;
  border-color: ${({ color }) => (color ? color : colors.primary)};
  font-weight: normal;
  &:hover,
  &:focus,
  &:active {
    background-color: ${colors.white + "50"};
    color: ${({ color }) => (color ? color : colors.primary)};
    border-color: ${({ color }) => (color ? color : colors.primary)};
  }
`;
